<script setup lang="ts">
import { watch } from "vue"
import TopNavBar from "./components/TopNavBar.vue"
import { RouterView, useRoute } from "vue-router"
import { storeToRefs } from "pinia"
import { useUserStore } from "@/stores/UserStore"
const route = useRoute()

// Microsoft Clarity — non-admin users only, production only
if (import.meta.env.MODE !== "development") {
  const userStore = useUserStore()
  const { loggedIn, admin, user } = storeToRefs(userStore)
  let clarityLoaded = false
  watch(
    [loggedIn, admin],
    ([li, isAdmin]) => {
      if (!li || isAdmin || clarityLoaded) return
      clarityLoaded = true
      ;(function (c: any, l, a, r, i, t?: any, y?: any) {
        c[a] =
          c[a] ||
          function () {
            ;(c[a].q = c[a].q || []).push(arguments)
          }
        t = l.createElement(r) as HTMLScriptElement
        t.async = 1
        t.src = "https://www.clarity.ms/tag/" + i
        y = l.getElementsByTagName(r)[0]
        y.parentNode.insertBefore(t, y)
      })(window, document, "clarity", "script", "58i0ehjs94")
      const email = (user.value as any)?.email
      if (email) (window as any).clarity?.("identify", email)
    },
    { immediate: true },
  )
}
</script>

<template>
  <div class="d-flex flex-column min-vh-100">
    <TopNavBar v-if="route.name !== 'pdfinvoice'" />
    <RouterView />
    <footer v-if="route.name !== 'pdfinvoice'" class="app-footer mt-auto">
      <div class="d-flex justify-content-center">Copyright © 2026 Babble-on Inc</div>
    </footer>
  </div>
</template>

<style scoped>
.app-footer {
  padding: 1rem;
  background: var(--p-content-background, #fff);
  border-top: 1px solid var(--bs-gray-200, #e9ecef);
  color: var(--bs-gray-600, #6c757d);
  font-size: 0.85rem;
}
</style>
